import { TypedDocumentNode, gql } from '@apollo/client';

import { Tooltip } from '@sorare/core/src/atoms/tooltip/Tooltip';
import {
  getPositionInitials,
  getPositionName,
} from '@sorare/core/src/lib/positions';

import { NBAPlayerPositionsWithTooltip_player } from './__generated__/index.graphql';

type Props = {
  player: NBAPlayerPositionsWithTooltip_player;
};

export const PlayerPositionsWithTooltip = ({
  player: { anyPositions },
}: Props) => {
  return (
    <>
      {anyPositions.map((p, i) => {
        return (
          <span key={p}>
            {i !== 0 && ', '}
            <Tooltip title={getPositionName(p)} placement="top">
              <span>{getPositionInitials(p)}</span>
            </Tooltip>
          </span>
        );
      })}
    </>
  );
};

PlayerPositionsWithTooltip.fragments = {
  player: gql`
    fragment NBAPlayerPositionsWithTooltip_player on NBAPlayer {
      slug
      anyPositions
    }
  ` as TypedDocumentNode<NBAPlayerPositionsWithTooltip_player>,
};
